export default __webpack_public_path__ + "static/media/landingBackground7.b7e9eb49.png";